import "core-js/modules/es7.symbol.async-iterator";
import "core-js/modules/es6.symbol";
import "core-js/modules/es6.string.iterator";
import "core-js/modules/es6.array.from";
import _typeof from "D:/Project/heshan/code/heshan_web/node_modules/@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es6.function.name";
import "core-js/modules/es6.regexp.to-string";
import "core-js/modules/web.dom.iterable";

function _createForOfIteratorHelper(o, allowArrayLike) { var it; if (typeof Symbol === "undefined" || o[Symbol.iterator] == null) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = o[Symbol.iterator](); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

import { setToken, setRefreshToken, removeToken, removeRefreshToken } from "@/util/auth";
import { Message } from "element-ui";
import { setStore, getStore } from "@/util/store";
import { isURL, validatenull } from "@/util/validate";
import { deepClone } from "@/util/util";
import website from "@/config/website";
import { setDefaultStation, queryGatewayList } from "@/api/deviceOverview/common";
import { loginByUsername, loginBySocial, getUserInfo, logout, refreshToken as _refreshToken, getButtons, platformDetail } from "@/api/user";
import { getTopMenu, getRoutes } from "@/api/system/menu";
import md5 from "js-md5";

function addPath(ele, first) {
  var menu = website.menu;
  var propsConfig = menu.props;
  var propsDefault = {
    label: propsConfig.label || "name",
    path: propsConfig.path || "path",
    icon: propsConfig.icon || "icon",
    children: propsConfig.children || "children"
  };
  var icon = ele[propsDefault.icon];
  ele[propsDefault.icon] = validatenull(icon) ? menu.iconDefault : icon;
  var isChild = ele[propsDefault.children] && ele[propsDefault.children].length !== 0;
  if (!isChild) ele[propsDefault.children] = [];

  if (!isChild && first && !isURL(ele[propsDefault.path])) {
    ele[propsDefault.path] = ele[propsDefault.path] + "/index";
  } else {
    ele[propsDefault.children].forEach(function (child) {
      addPath(child);
    });
  }
}

var user = {
  state: {
    tenantId: getStore({
      name: "tenantId"
    }) || "",
    userInfo: getStore({
      name: "userInfo"
    }) || [],
    permission: getStore({
      name: "permission"
    }) || {},
    roles: [],
    stationObj: getStore({
      name: "stationObj"
    }) || {},
    menu: getStore({
      name: "menu"
    }) || [],
    menuId: getStore({
      name: "menuId"
    }) || [],
    menuAll: getStore({
      name: "menuAll"
    }) || [],
    token: getStore({
      name: "token"
    }) || "",
    refreshToken: getStore({
      name: "refreshToken"
    }) || "",
    waylist: getStore({
      name: "waylist"
    }) || ""
  },
  actions: {
    //根据用户名登录
    LoginByUsername: function LoginByUsername(_ref, userInfo) {
      var state = _ref.state,
          commit = _ref.commit;
      var that = this;
      return new Promise(function (resolve, reject) {
        loginByUsername(userInfo.tenantId, userInfo.username, md5(userInfo.password), userInfo.type, userInfo.key, userInfo.code, state.refreshToken).then(function (res) {
          var data = res.data;

          if (data.error_description) {
            Message({
              message: data.error_description,
              type: "error"
            });
          } else {
            //  commit('SET_STATIONOBJ', {
            //    stationId: 12,
            //    stationName: '设定设备'
            //  })
            commit("SET_TOKEN", data.access_token);
            commit("SET_REFRESH_TOKEN", data.refresh_token);
            commit("SET_TENANT_ID", data.tenant_id);
            commit("SET_USER_INFO", data);
            commit("DEL_ALL_TAG");
            commit("CLEAR_LOCK");
          }

          resolve(data);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    getplatformDetail: function getplatformDetail(_ref2, id) {
      var commit = _ref2.commit;
      return new Promise(function (resolve, reject) {
        platformDetail(id).then(function (res) {
          var userpro = res.data.data.userProject;
          userpro = userpro ? JSON.parse(userpro) : userpro;
          var userdev = res.data.data.userDevice ? JSON.parse(res.data.data.userDevice) : res.data.data.userDevice;
          commit("SET_STATIONOBJ", {
            devid: userdev && userdev.deviceId ? userdev.deviceId : 0,
            proid: userpro && userpro.projectId ? userpro.projectId : 0,
            onenetId: userdev && userdev.onenetId,
            devcode: userdev && userdev.devCode
          });
          resolve(res);
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 设置默认配置选择
    SetDefaultStationFun: function SetDefaultStationFun(_ref3, data) {
      var commit = _ref3.commit;
      return new Promise(function (resolve, reject) {
        setDefaultStation({
          id: data.id,
          type: data.type1
        }).then(function (response) {
          console.log(data);

          if (data.type1 === "device") {
            commit("SET_STATIONOBJ", {
              devid: data.id,
              proid: data.projectId,
              onenetId: data.onenetId,
              devcode: data.devCode
            });
          } else {
            commit("SET_STATIONOBJ", {
              proid: data.id,
              devid: data.devid,
              onenetId: data.onenetId,
              devcode: data.devCode
            });
          }

          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    //根据手机号登录
    LoginByPhone: function LoginByPhone(_ref4, userInfo) {
      var commit = _ref4.commit;
      return new Promise(function (resolve) {
        loginByUsername(userInfo.phone, userInfo.code).then(function (res) {
          var data = res.data.data;
          commit("SET_TOKEN", data);
          commit("DEL_ALL_TAG");
          commit("CLEAR_LOCK");
          resolve();
        });
      });
    },
    //根据第三方信息登录
    LoginBySocial: function LoginBySocial(_ref5, userInfo) {
      var commit = _ref5.commit;
      return new Promise(function (resolve) {
        loginBySocial(userInfo.tenantId, userInfo.source, userInfo.code, userInfo.state).then(function (res) {
          var data = res.data;

          if (data.error_description) {
            Message({
              message: data.error_description,
              type: "error"
            });
          } else {
            commit("SET_TOKEN", data.access_token);
            commit("SET_REFRESH_TOKEN", data.refresh_token);
            commit("SET_USER_INFO", data);
            commit("DEL_ALL_TAG");
            commit("CLEAR_LOCK");
          }

          resolve();
        });
      });
    },
    //获取用户信息
    GetUserInfo: function GetUserInfo(_ref6) {
      var commit = _ref6.commit;
      return new Promise(function (resolve, reject) {
        getUserInfo().then(function (res) {
          var data = res.data.data;
          commit("SET_ROLES", data.roles);
          resolve(data);
        }).catch(function (err) {
          reject(err);
        });
      });
    },
    //刷新token
    refreshToken: function refreshToken(_ref7) {
      var state = _ref7.state,
          commit = _ref7.commit;
      window.console.log("handle refresh token");
      return new Promise(function (resolve, reject) {
        _refreshToken(state.refreshToken, state.tenantId).then(function (res) {
          var data = res.data;
          commit("SET_TOKEN", data.access_token);
          commit("SET_REFRESH_TOKEN", data.refresh_token);
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    // 登出
    LogOut: function LogOut(_ref8) {
      var commit = _ref8.commit;
      return new Promise(function (resolve, reject) {
        logout().then(function () {
          commit("SET_TOKEN", "");
          commit("SET_MENU", []);
          commit("SET_MENU_ID", {});
          commit("SET_MENU_ALL", []);
          commit("SET_ROLES", []);
          commit("SET_TAG_LIST", []);
          commit("DEL_ALL_TAG");
          commit("CLEAR_LOCK");
          removeToken();
          removeRefreshToken();
          resolve();
        }).catch(function (error) {
          reject(error);
        });
      });
    },
    //注销session
    FedLogOut: function FedLogOut(_ref9) {
      var commit = _ref9.commit;
      return new Promise(function (resolve) {
        commit("SET_TOKEN", "");
        commit("SET_MENU_ID", {});
        commit("SET_MENU_ALL", []);
        commit("SET_MENU", []);
        commit("SET_ROLES", []);
        commit("SET_TAG_LIST", []);
        commit("DEL_ALL_TAG");
        commit("CLEAR_LOCK");
        removeToken();
        removeRefreshToken();
        resolve();
      });
    },
    //获取顶部菜单
    GetTopMenu: function GetTopMenu() {
      return new Promise(function (resolve) {
        getTopMenu().then(function (res) {
          var data = res.data.data || [];
          resolve(data);
        });
      });
    },
    // 获取项目列表
    GetwayList: function GetwayList(_ref10, userinfo) {
      var commit = _ref10.commit,
          dispatch = _ref10.dispatch;
      return new Promise(function (resolve) {
        queryGatewayList(userinfo).then(function (res) {
          var data = res.data.data.records;
          var menu = deepClone(data);
          var arr = [];
          menu.forEach(function (ele) {
            arr.push(ele.id);
          });
          arr = arr.toString();
          commit("SET_WAY_LIST", arr);
          resolve();
        });
      });
    },
    //获取系统菜单
    GetMenu: function GetMenu(_ref11, topMenuId) {
      var commit = _ref11.commit,
          dispatch = _ref11.dispatch;
      return new Promise(function (resolve) {
        getRoutes(topMenuId).then(function (res) {
          var data = res.data.data;
          var menu = deepClone(data);
          menu.forEach(function (ele) {
            addPath(ele, true);
          });
          commit("SET_MENU_ALL", menu);
          commit("SET_MENU", menu);
          dispatch("GetButtons");
          resolve(menu);
        });
      });
    },
    //获取系统按钮
    GetButtons: function GetButtons(_ref12) {
      var commit = _ref12.commit;
      return new Promise(function (resolve) {
        getButtons().then(function (res) {
          var data = res.data.data;
          commit("SET_PERMISSION", data);
          resolve();
        });
      });
    }
  },
  mutations: {
    SET_WAY_LIST: function SET_WAY_LIST(state, waylist) {
      state.waylist = waylist;
      setStore({
        name: "waylist",
        content: state.waylist
      });
    },
    SET_STATIONOBJ: function SET_STATIONOBJ(state, active) {
      state.stationObj = active;
      setStore({
        name: "stationObj",
        content: state.stationObj
      });
    },
    SET_TOKEN: function SET_TOKEN(state, token) {
      setToken(token);
      state.token = token;
      setStore({
        name: "token",
        content: state.token
      });
    },
    SET_MENU_ID: function SET_MENU_ID(state, menuId) {
      state.menuId = menuId;
      setStore({
        name: "menuId",
        content: state.menuId
      });
    },
    SET_MENU_ALL: function SET_MENU_ALL(state, menuAll) {
      state.menuAll = menuAll;
      setStore({
        name: "menuAll",
        content: state.menuAll
      });
    },
    SET_MENU: function SET_MENU(state, menu) {
      state.menu = menu;
      setStore({
        name: "menu",
        content: state.menu
      });
      if (validatenull(menu)) return; //合并动态路由去重

      var menuAll = state.menuAll;
      menuAll = menuAll.concat(menu).reverse();
      var newMenu = [];

      var _iterator = _createForOfIteratorHelper(menuAll),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var item1 = _step.value;
          var flag = true;

          var _iterator2 = _createForOfIteratorHelper(newMenu),
              _step2;

          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var item2 = _step2.value;

              if (item1.name === item2.name || item1.path === item2.path) {
                flag = false;
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }

          if (flag) {
            newMenu.push(item1);
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      state.menuAll = newMenu;
      setStore({
        name: "menuAll",
        content: state.menuAll
      });
    },
    SET_REFRESH_TOKEN: function SET_REFRESH_TOKEN(state, refreshToken) {
      setRefreshToken(refreshToken);
      state.refreshToken = refreshToken;
      setStore({
        name: "refreshToken",
        content: state.refreshToken
      });
    },
    SET_TENANT_ID: function SET_TENANT_ID(state, tenantId) {
      state.tenantId = tenantId;
      setStore({
        name: "tenantId",
        content: state.tenantId
      });
    },
    SET_USER_INFO: function SET_USER_INFO(state, userInfo) {
      if (validatenull(userInfo.avatar)) {
        userInfo.avatar = "/img/bg/img-logo.png";
      }

      state.userInfo = userInfo;
      setStore({
        name: "userInfo",
        content: state.userInfo
      });
    },
    SET_ROLES: function SET_ROLES(state, roles) {
      state.roles = roles;
    },
    SET_PERMISSION: function SET_PERMISSION(state, permission) {
      var result = [];

      function getCode(list) {
        list.forEach(function (ele) {
          if (_typeof(ele) === "object") {
            var chiildren = ele.children;
            var code = ele.code;

            if (chiildren) {
              getCode(chiildren);
            } else {
              result.push(code);
            }
          }
        });
      }

      getCode(permission);
      state.permission = {};
      result.forEach(function (ele) {
        state.permission[ele] = true;
      });
      setStore({
        name: "permission",
        content: state.permission
      });
    }
  }
};
export default user;